// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"2531":"e08662a2","8525":"39b8301f"}[chunkId] || chunkId) + "." + {"485":"97ef342c4fe7f4a5","809":"250523367dc521ad","2460":"1193e8e9988b18c3","2531":"bf2bc7dd1fa712a8","8525":"a0cccda50e033233","9539":"04d8e7b5b3fae161"}[chunkId] + ".js";
};